var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDashboardTotalPlantsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GardenDashboardTotalPlantsSVG 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dirtMound"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0146 88.1529C8.70357 88.1529 24.6166 64.4588 50.0816 64.4588C75.5467 64.4588 91.2668 88.1529 78.1102 88.1529C63.834 88.1529 37.8096 88.1529 22.0146 88.1529Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leftPlant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.3289 64.7604C49.3289 64.7604 49.8055 51.1006 46.5205 43.2971C43.2355 35.4938 36.9416 33.2451 36.9416 33.2451",
    stroke: "#065D44",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.9416 28.8707C34.6473 39.7582 23.7207 35.9629 17.3858 22.924C12.3832 12.6274 39.0348 18.9384 36.9416 28.8707Z",
    stroke: "#065D44",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rightPlant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.1723 64.4588C51.1723 64.4588 50.3951 56.8729 53.4047 52.2725C56.4143 47.6719 62.1199 46.0568 62.1199 46.0568",
    stroke: "#065D44",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.7182 38.7484C66.4129 37.0357 59.2201 38.9676 62.1199 46.0568C65.1961 53.5766 78.7978 41.034 71.7182 38.7484Z",
    stroke: "#065D44",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDashboardTotalPlantsSvg);
export default __webpack_public_path__ + "static/media/GardenDashboardTotalPlantsSVG.338d0de05f06458f7b950b47e0959ecd.svg";
export { ForwardRef as ReactComponent };